// extracted by mini-css-extract-plugin
module.exports = {"back":"GoBackButton_back__13Xn_","move":"GoBackButton_move__1ZKns","fadeIn":"GoBackButton_fadeIn__2_4cp","fadeOut":"GoBackButton_fadeOut__2Jlan"};